__turbopack_context__.v({
  "text-shimmer": "H5gOIW_text-shimmer",
  "textShimmer": "H5gOIW_textShimmer",
});
